var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-dialog',{attrs:{"message":"该用户已脱单，资料已下架","confirmButtonText":"知道了","close-on-click-overlay":true},on:{"close":_vm.close},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}})}
var staticRenderFns = []

export { render, staticRenderFns }